var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2659_38116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99886 18.3332C5.39636 18.3332 1.66553 14.6023 1.66553 9.99984C1.66553 5.39734 5.39636 1.6665 9.99886 1.6665C14.6014 1.6665 18.3322 5.39734 18.3322 9.99984C18.3322 14.6023 14.6014 18.3332 9.99886 18.3332ZM13.7497 15.4165V14.1665L9.99886 9.99984L13.7497 5.4165V4.309H6.24967V5.4165L9.99886 9.99984V9.1665L8.33301 7.08317L9.99967 7.49984L11.6663 7.08317L9.99886 9.1665V9.99984L10.4163 14.1665L13.333 14.5832V14.9998H6.66634V14.5832L9.58301 14.1665L9.99886 9.99984L6.24967 14.1665V15.4165H13.7497Z",
    fill: "#C89000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99886 18.3332C5.39636 18.3332 1.66553 14.6023 1.66553 9.99984C1.66553 5.39734 5.39636 1.6665 9.99886 1.6665C14.6014 1.6665 18.3322 5.39734 18.3322 9.99984C18.3322 14.6023 14.6014 18.3332 9.99886 18.3332ZM13.7497 15.4165V14.1665L9.99886 9.99984L13.7497 5.4165V4.309H6.24967V5.4165L9.99886 9.99984V9.1665L8.33301 7.08317L9.99967 7.49984L11.6663 7.08317L9.99886 9.1665V9.99984L10.4163 14.1665L13.333 14.5832V14.9998H6.66634V14.5832L9.58301 14.1665L9.99886 9.99984L6.24967 14.1665V15.4165H13.7497Z",
    fill: "#C89000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99886 18.3332C5.39636 18.3332 1.66553 14.6023 1.66553 9.99984C1.66553 5.39734 5.39636 1.6665 9.99886 1.6665C14.6014 1.6665 18.3322 5.39734 18.3322 9.99984C18.3322 14.6023 14.6014 18.3332 9.99886 18.3332ZM13.7497 15.4165V14.1665L9.99886 9.99984L13.7497 5.4165V4.309H6.24967V5.4165L9.99886 9.99984V9.1665L7.91634 6.6665L9.99886 7.08317L12.083 6.6665L9.99886 9.1665V9.99984L10.4163 13.7498L13.333 14.5832V14.9998H6.66634V14.5832L9.58301 13.7498L9.99886 9.99984L6.24967 14.1665V15.4165H13.7497Z",
    fill: "#C89000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2659_38116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationPendingIcon);
export default __webpack_public_path__ + "static/media/verification_pending_icon.85fd788b3cbca39a51df9c141a1bb363.svg";
export { ForwardRef as ReactComponent };